module.exports = __webpack_public_path__ + "img/chessboard.9cc8403d.svg";